import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const title: SxStyle = {
  color: (p) => p.palette.primary[600],
  fontSize: (p) => p.typography.h5.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const summary: SxStyleFunc<boolean | undefined> = (open) => ({
  background: open
    ? (p) => p.palette.primary[50]
    : (p) => p.palette.common.white,
  borderRadius: open ? (p) => p.spacing(2, 2, 0, 0) : (p) => p.spacing(1),
  borderColor: (p) => p.palette.primary[100],
});

export const icon: SxStyleFunc<boolean | undefined> = (open) => ({
  color: open ? (p) => p.palette.primary[600] : (p) => p.palette.primary[400],
});

export const detail: SxStyleFunc<boolean | undefined> = () => ({
  borderColor: (p) => p.palette.primary[100],
  borderRadius: (p) => p.spacing(0, 0, 1, 1),
});
